/* eslint-disable security/detect-object-injection */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, ToggleField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from './ExtNavTripDetailsComponent.module.scss';
import metadata from './ExtNavTripDetailsComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';


function ExtNavTripDetailsComponent(props) {

    const {
        updateWizardData,
        submissionVM,
        index,
        basePath,
        extNavTripDetailsTablePath
    } = props;

    let {
        data: extNavTripDetailsTableVM
    } = props;

    console.log("Trip Details submissionVM: " , submissionVM);

    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);


    const addExtNavTripDetailsTable = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            extNavTripDetailsTableVM.value = extNavTripDetailsTableVM.value || []

           const ExtNavTripDetailsTableObjVM = viewModelService.create(
                {},
                "pc",
                "edgegen.capabilities.policyjob.lob.recmarproduct.coverables.dto.marinepleasurecraft.boats.subdto.TripDetailsDTO"
            );

            ExtNavTripDetailsTableObjVM.isValidationReq = true;

            extNavTripDetailsTableVM.pushElement(
                ExtNavTripDetailsTableObjVM
            );
            
            
            _.set(submissionVM, extNavTripDetailsTablePath, extNavTripDetailsTableVM);

            const newSubmissionVM = viewModelService.clone(submissionVM);
            updateWizardData(newSubmissionVM);

            addMarinaDetailsTable();
            addCrewMembersTable();
        },
        [submissionVM, updateWizardData, extNavTripDetailsTableVM, viewModelService]
    );

    const addMarinaDetailsTable = useCallback(
        () => {

            let marinaDetailsTablePath = `${basePath}.marinaDetails`;

            let marinaDetailsTableVM = _.get(submissionVM, marinaDetailsTablePath);
            marinaDetailsTableVM.value = marinaDetailsTableVM.value || [];

           const marinaDetailsTableObjVM = viewModelService.create(
                {},
                "pc",
                "edgegen.capabilities.policyjob.lob.recmarproduct.coverables.dto.marinepleasurecraft.boats.subdto.MarinaDetailsDTO"
            );

            marinaDetailsTableObjVM.isValidationReq = true;

            marinaDetailsTableVM.pushElement(
                marinaDetailsTableObjVM
            );
            
            _.set(submissionVM, marinaDetailsTablePath, marinaDetailsTableVM);
            const newSubmissionVM = viewModelService.clone(submissionVM);
            updateWizardData(newSubmissionVM);
        },
        [submissionVM, updateWizardData, viewModelService]
    );

    const addCrewMembersTable = useCallback(
        () => {

            let crewMembersTablePath = `${basePath}.crewMembers`;

            let crewMembersTableVM = _.get(submissionVM, crewMembersTablePath);
            crewMembersTableVM.value = crewMembersTableVM.value || [];

           const crewMembersTableObjVM = viewModelService.create(
                {},
                "pc",
                "edgegen.capabilities.policyjob.lob.recmarproduct.coverables.dto.marinepleasurecraft.boats.subdto.CrewMembersDTO"
            );

            crewMembersTableObjVM.isValidationReq = true;

            crewMembersTableVM.pushElement(
                crewMembersTableObjVM
            );
            
            _.set(submissionVM, crewMembersTablePath, crewMembersTableVM);
            const newSubmissionVM = viewModelService.clone(submissionVM);
            updateWizardData(newSubmissionVM);
        },
        [submissionVM, updateWizardData, viewModelService]
    );




    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeTripDetailItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            extNavTripDetailsTableVM.value.splice(index, 1);
            _.set(submissionVM, extNavTripDetailsTablePath, extNavTripDetailsTableVM);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, extNavTripDetailsTablePath, extNavTripDetailsTableVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'numFie') {

                const value = index + 1;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'voyageDetails' || path === 'ifYesVesselDetails' || path === 'crewName') {
                const value = item[path] ? item[path] : '';
                const disabled = path === 'vesselLeftAttended' && (item['vesselLeftAttended'] === undefined || item['vesselLeftAttended'] === false) ? true : false;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        disabled={disabled}
                        value={value}
                    />
                );
            }

            if (path === 'months' || path === 'crewExperience' || path === 'noOfCrewMembers') {
                const value = item[path] ? item[path] : 0;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            } 

        
            if(path === "vesselLeftAttended") {

                const value = item[path] ? item[path] : false;
                return (
                    <ToggleField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={[
                            {
                              displayName: 'Yes',
                              id: 'true'
                            },
                            {
                              displayName: 'No',
                              id: 'false'
                            }
                          ]}
                    />
                );
            }

        }, [extNavTripDetailsTablePath, extNavTripDetailsTableVM?.value, handleValueChange, submissionVM?.value])

    const removeExtNavTripDetailsTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeTripDetailItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeTripDetailItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`extNavTripDetailsTable`]: {
            data: extNavTripDetailsTableVM && extNavTripDetailsTableVM.length > 0 ? extNavTripDetailsTableVM.value : []
        }

    }), [extNavTripDetailsTableVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addExtNavTripDetailsTable,
            getTableCell,
            removeExtNavTripDetailsTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            extNavTripDetailsTableVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [extNavTripDetailsTableVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={extNavTripDetailsTableVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ExtNavTripDetailsComponent.propTypes = wizardProps;
export default withRouter(ExtNavTripDetailsComponent);
